import React from 'react'
import { cn } from '../../utils/formatter'
import loadingGif from '../../assets/loading_demandas.gif'

interface LoadingProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  message?: string
}

/**
 * Componente de loading unificado usando o GIF animado
 * 
 * @param size - Tamanho do loading (xs: 24px, sm: 44px, md: 84px, lg: 128px, xl: 160px)
 * @param className - Classes adicionais
 * @param message - Mensagem opcional abaixo do loading
 */
export const Loading: React.FC<LoadingProps> = ({ 
  size = 'md', 
  className = '',
  message 
}) => {
  const sizeClasses = {
    xs: 'w-6 h-6',
    sm: 'w-11 h-11',
    md: 'w-[5.25rem] h-[5.25rem]',
    lg: 'w-32 h-32',
    xl: 'w-40 h-40'
  }
  
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3', className)}>
      <img 
        src={loadingGif} 
        alt="Carregando..." 
        className={cn('object-contain', sizeClasses[size])}
      />
      {message && (
        <p className='text-sm text-muted-foreground dark:text-gray-400 text-center'>
          {message}
        </p>
      )}
    </div>
  )
}

/**
 * Componente inline de loading (sem wrapper flex)
 */
export const LoadingInline: React.FC<Omit<LoadingProps, 'message'>> = ({ 
  size = 'sm', 
  className = '' 
}) => {
  const sizeClasses = {
    xs: 'w-6 h-6',
    sm: 'w-11 h-11',
    md: 'w-[5.25rem] h-[5.25rem]',
    lg: 'w-32 h-32',
    xl: 'w-40 h-40'
  }
  
  return (
    <img 
      src={loadingGif} 
      alt="Carregando..." 
      className={cn('object-contain', sizeClasses[size], className)}
    />
  )
}

export default Loading

